import { DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppFilter } from '@app/shared/models';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  OrganizationService,
  PdfViewerService,
} from 'src/modules/features/admin/services';
import { DocumentTypeService } from 'src/modules/features/setting/services';
import { CompanyService, DashboardProvider } from '../../services';
import { AolService } from '../../services/aol';

interface IViewHistoryModalContext {
  title: string;
  data?: any;
  documentTypes?: any;
  isEdit: any;
}
@Component({
  selector: 'app-link-document-type-modal',
  templateUrl: './link-document-type-modal.component.html',
  styleUrls: ['./link-document-type-modal.component.scss'],
})
export class LinkDocumentModalComponent implements OnInit {
  @ViewChild('input') input: ElementRef;
  allPendingHistory;
  pendingHistory;
  success: any;
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId: string;
  allHistory: any = [];
  isPending: boolean = this.modal.context.data
    ? this.modal.context.data.isPending
    : false;
  isChecked: string;

  collapseHistory = [];
  selectedRequest: any;
  detail: any;
  documents;
  states;
  origin;
  nationality;
  countries;
  documentFilterCompany = {
    groupOp: 'OR',
    rules: [],
  };
  documentsType;
  allAffiliateTypeNames = [];
  pendingArr: boolean[] = [];
  allStatus: any;
  documentData;
  personnelStructures: any[] = [];
  baseUrl = environment.API_SERVER;
  affiliateTypeId;
  documentTypeName;
  isEditFile;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    private companySvc: CompanyService,
    private organizationSvc: OrganizationService,
    private documentTypeSvc: DocumentTypeService,
    public modal: SuiModal<IViewHistoryModalContext, void, void>,
    private companyOwnershipService: CompanyOwnershipService,
    private dashboardSvc: DashboardProvider,
    private AolService: AolService,
    private activatedRoute: ActivatedRoute,
    private pdfViewerService: PdfViewerService
  ) {
    this.documentTypeName = this.modal.context.data;
    this.organizationId = window.localStorage.getItem('organizationId');
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10 });
    console.log(this.modal.context.documentTypes, this.documentTypeName);
    let data = this.modal.context.documentTypes.filter((item) => {
      return item.documentTypeName === this.documentTypeName;
    });
    this.isEditFile = this.modal.context.isEdit;
    console.log(this.isEditFile, 'edi');
    console.log(data);
    let filterData = {
      field: 'document.documentTypeId.documentTypeId',
      op: 'eq',
      data: data[0].documentTypeId,
    };
    this.documentFilterCompany.rules.push(filterData);
    this.getAllDocumentTypes(1);
    // this.getPage(1);
  }
  onBoxChecked(value) {
    if (value.checkbox) {
      console.log(value);
      this.linkedDoc.push(value);
    } else {
      console.log(value);
      if (this.linkedDoc.length > 0) {
        let indexToRemove;
        this.linkedDoc = this.linkedDoc.filter((item) => {
          return item.documentTypeId !== value.documentTypeId;
        });
      }
    }
  }
  viewDocument(data: any) {
    this.pdfViewerService.viewPdf(data);
  }
  ngOnInit(): void {}
  linkedDoc: any = [];
  getAllDocumentTypes(page) {
    this.pending = true;
    this.filter.page = page;
    this.filter.filters = JSON.stringify(this.documentFilterCompany);
    this.filter['organizationId'] = this.organizationId;
    this.AolService.getAllSupportingDocumentTypes({
      organizationId: this.organizationId,
      params: this.filter,
    })
      .pipe(
        tap((res) => {
          this.totalItems = +res['records'];
          this.currentPage = page;
          this.rows = this.filter.rows;
        })
      )
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.documents = res.rows;
          if (this.isEditFile) {
            this.documents = res.rows.filter((item) => {
              return item.documentId !== this.isEditFile.documentId;
            });
          }
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }

  nextPage(page: number) {
    this.currentPage = page;
    this.getAllDocumentTypes(this.currentPage);
  }
  submit() {
    if (this.isEditFile && this.linkedDoc.length > 1) {
      this.error = 'Select Only one document since you are editing';
      return;
    }
    this.success = 'Document successfully linked';
    this.pending = true;
    setTimeout(() => {
      this.modal.approve(this.linkedDoc);
    }, 1000);
  }
}

export class LinkDocumentModal extends ComponentModalConfig<
  IViewHistoryModalContext,
  void,
  void
> {
  constructor(
    title: string,
    isEdit: any,
    data?: any,
    documentTypes?: any,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(LinkDocumentModalComponent, { title, isEdit, data, documentTypes });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
